import { TaskStatusChangedNotification } from "#/store/types";
import { constructURLToTask } from "#/util";
import React from "react";
import style from "./index.module.scss";
import ItemWrapper from "./ItemWrapper";
import { DerivedNotificationItemProps } from "./types";

const TaskStatusChangedNotificationItem = React.forwardRef(
  (props: DerivedNotificationItemProps<TaskStatusChangedNotification>, ref: React.Ref<any>) => (
    <ItemWrapper
      ref={ref}
      onClick={() => {
        props.push(constructURLToTask(props.notification.task_model));
      }}
      notification={props.baseNotification}
    >
      <span className={style["notification-menu-item__text"]}>
        Статус задачи {`"${props.notification.task_model.name}"`} изменился на
        {`"${props.notification.new_status}"`}
      </span>
    </ItemWrapper>
  ),
);

export default TaskStatusChangedNotificationItem;
